import {BaseModel} from './BaseModel';
import {getCurrentUserUUID} from '../utils/generalUtils';
import {getUserData} from '../services/utilityServices';

export interface IUserModelProps {
    UniqueID?: string;
    id?: string;
    Company?: string;
    FirstName?: string;
    MiddleName?: string;
    LastName?: string;
    Email?: string;
    Access_Level?: string;
    AccessLevel?: string;
    JobTitle?: string;
    JobDescription?: string;
    DateCreated?: number;
    DateUpdate?: string;
    PhoneNumber?: number;
    SignURL?: string;
    UserId?: string;
    Id: string;
    UserImage: string;
    SignFile: File;
    ProfilePicFile: File;
    Modules?: string[];
    Active?: boolean;
    Organization?: string;
    OrganizationName?: string;
}

export class UserModel extends BaseModel<IUserModelProps> {
    constructor(props: IUserModelProps) {
        super(props);
    }

    public static get(id: string) {
        return UserModel.getSingleInstance<IUserModelProps>(id);
    }

    public static getCurrentUserInstance(id: string = getCurrentUserUUID(), state?) {
        return UserModel.getSingleInstance<IUserModelProps>(id, state);
    }

    public static list() {
        return UserModel.listAll<IUserModelProps>();
    }

    public static isSuperAdmin(instance = this.props) {
        return getUserData().accessLevel === 'L1';
    }

    public static isAdmin(instance = this.props) {
        return getUserData().accessLevel === 'L2';
    }

    public static isTrainee(instance = this.props) {
        return getUserData().accessLevel === 'L3';
    }

    public static resource: string = 'user';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/UserModel.ts